export default "__VITE_ASSET__78fb82d6__"